import { render, staticRenderFns } from "./HomoSectionsList.vue?vue&type=template&id=5f663562&scoped=true"
import script from "./HomoSectionsList.vue?vue&type=script&lang=js"
export * from "./HomoSectionsList.vue?vue&type=script&lang=js"
import style0 from "./HomoSectionsList.vue?vue&type=style&index=0&id=5f663562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f663562",
  null
  
)

export default component.exports